import React from "react";
import dynamic from "next/dynamic";
const Location = dynamic(() => import("@/app/location"), {
  ssr: false,
});

const Page = () => {
  return <Location />;
};

export default Page;
